<script setup lang="ts">
import { useModalStore } from '../../../store/modal'
import { useTicketStore } from '../../../store/tickets'
import ActionModalBase from "../ActionModalBase.vue";

const modalStore = useModalStore()
const ticketStore = useTicketStore()

const markAwaitingExternal = async () => {
    await ticketStore.markAwaitingExternal(modalStore.props.id)
    modalStore.close(true)
}

const openExternal = () => {
    window.open(modalStore.props.external_url, '_blank')
}
</script>

<template>
    <action-modal-base>
        <button @click.prevent="modalStore.open('AssignTicket', {id: modalStore.props.id}, 'body', 'bottom-right')">{{ modalStore.props.assigned ? "Reassign" : "Assign" }}</button>
        <button v-if="!['awaiting-external', 'complete'].includes(modalStore.props.status)" @click.prevent="markAwaitingExternal()">Mark awaiting external</button>
        <button v-if="modalStore.props.status !== 'complete'" @click.prevent="modalStore.open('CompleteTicket', {id: modalStore.props.id}, 'body', 'bottom-right')">Mark as complete</button>
<!--        <button v-if="modalStore.props.external_url" @click.prevent="openExternal()">View in Kayako</button>-->
    </action-modal-base>
</template>

<style scoped lang="scss">
.action-modal {
    height: auto;
}
</style>
